import React from "react";

export const source = "";

export default class VideoPlayer extends React.Component {

  componentDidMount() {
  }

  // destroy player on unmount
  componentWillUnmount() {
  }

  shouldComponentUpdate(nextProps){

      if (nextProps.source !== this.props.source) {
        return true;
      } else {
        return false;
      }
 }

  render() {
    return (
      <div>
            <iframe 
	      className="skill-video" 
              title="job video"
              src={this.props.source}
              frameBorder="0" 
              scrolling="no" allowFullScreen/>
      </div>

    );
  }
}
